<template>
    <div class="modal vc_modal my_account_modal" :class="{ 'show': isShowModal}">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content my_account_modal_content p_0">
                <button type="button" class="btn-close" @click="closeModal()"></button>
                <div class="modal-body p_0">
                    <h5 class="common_subtitle pb_15  font_18p border-lightgray-bottom pt_15 pl_15">{{ modalData?.name }} details</h5>
                    <div class="p_20">
                        <div class="row">
                            <div class="col-6">
                                <div class="table_responsive w-100">
                                    <table class="common_table table table_bordered table-hover w-100 align-middle">
                                        <tbody>
                                            <tr>
                                                <th class="border_top_none transparent_bg"> Service</th>
                                                <td>{{ modalData?.cloudService?.name }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Name</th>
                                                <td>{{ modalData?.name }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Kt platform</th>
                                                <td>{{ modalData?.kt_platform == 'g' ? 'G' : 'D' }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Region</th>
                                                <td>{{ modalData?.serverRegion?.name }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Type</th>
                                                <td>{{ modalData?.disk_type }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Product</th>
                                                <td>{{ modalData?.disk_product_type }}</td>
                                            </tr>
                                            <tr>
                                                <th class="border_bottom_none transparent_bg">Space</th>
                                                <td class="border_bottom_none">{{ modalData?.space }}GB</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> 
                            </div>
                            <div class="col-6">
                                <div class="table_responsive w-100">
                                    <table class="common_table table table_bordered table-hover w-100 align-middle">
                                        <tbody>
                                            <tr>
                                                <th class="transparent_bg">IOPS</th>
                                                <td>{{ modalData?.iops }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Server name</th>
                                                <td>{{ modalData?.cloudServer?.server_name }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Status</th>
                                                <td>{{ modalData?.status }}</td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Billing type</th>
                                                <td>
                                                    {{ billing_type }}
                                                    <span class="ml_20" v-if="modalData?.disk_type != 'default'">
                                                        <button v-if="hasPermission('Update') && modalData.kt_platform == 'g'" type="button" class="btn btn-outline-primary btn-sm" title="Change billing type" @click.prevent="openBillingTypeModal()">
                                                            <i class="fas fa-edit"></i>
                                                        </button>
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="transparent_bg">Initiated at</th>
                                                <td>{{ modalData?.initiated_at }}</td>
                                            </tr>
                                            <tr>
                                                <th class="border_bottom_none transparent_bg">Started at</th>
                                                <td class="border_bottom_none">{{ modalData?.started_at }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> 
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <ServerBillingTypeEditModal
            v-if="showBillingTypeModal"
            :showBillingTypeModal="showBillingTypeModal"
            :modalData="modalData"
            @closeBillingTypeModal="closeBillingTypeModal"
        />
    </div>
</template>

<script>
import ServerBillingTypeEditModal from "./ServerBillingTypeEditModal.vue";
import {mapGetters} from "vuex";
import {checkPermission} from "@/mixins/permissionsHelper";
export default {
    name: "details-modal",
    components: { ServerBillingTypeEditModal },
    props: {
        isShowModal: {
            type: Boolean,
            required: true
        },
        modalData: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            billing_type: this.modalData?.billing_type,
            showBillingTypeModal: false,
        }
    },
    watch: {
        
    },
    computed: {
        ...mapGetters({
        permissions: 'serverPermissions/getServicePermission'
        }),
    },
    created() {
        
    },
    methods: {
        openBillingTypeModal(){
            this.showBillingTypeModal = true
            this.editModalData = this.modalData
        },
        closeBillingTypeModal(value = null){
            this.billing_type = value
            this.showBillingTypeModal = false
        },
        closeModal() {
            this.$emit('closeModal')
        },
      hasPermission(action) {
        let entity = this.permissions?.cloud_sub_service?.length ? this.permissions?.cloud_sub_service[0] : null;
        return checkPermission(this.permissions, entity, action);
      },
    }
}
</script>
<style scoped>
    .modal{
        background-color: rgb(0 0 0 / 15%);
    }
</style>
